import React from "react";
import { Button, TagBox, TextBox } from "devextreme-react";
import TableFilterSelect from "./tableFilterSelect";
import RangeFilter from "./rangeFilter";
import {
  filterType
} from "../../helpers/filterHelper";
import SelectTipo from "./SelectTipo";
import NumberRangeFilter from "./numberRangeFilter";
import { Tooltip } from "devextreme-react/ui/tooltip";

class TableFilter extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showFilters: props.show,
      focus: false,
      selectedFilters: [],
      textSearch: "",
      showBtnFilter: false,
      showBtnFilterPrev: false,
      showBtnFilterDown: false,
    };
  }

  componentDidMount = () => {
    if (this.props.selectedMainFilter) {
      let initFilter = {
        value: this.props.selectedMainFilter.value,
        column:
          this.props.selectedMainFilter.column === undefined
            ? ""
            : this.props.selectedMainFilter.column,
      };
      let newFilter = [...this.state.selectedFilters, initFilter];
      this.setState({ selectedFilters: newFilter });
    }
  };

  handleShowFilter = () => {
    this.setState({ showBtnFilter: true });
  };
  handleShowFilterOut = () => {
    this.setState({ showBtnFilter: false });
  };

  handleShowFilterPrev = () => {
    this.setState({ showBtnFilterPrev: true });
  };
  handleShowFilterPrevOut = () => {
    this.setState({ showBtnFilterPrev: false });
  };

  handleShowFilterDown = () => {
    this.setState({ showBtnFilterDown: true });
  };
  handleShowFilterDownOut = () => {
    this.setState({ showBtnFilterDown: false });
  };

  showHideFilters = () => {
    // const show = !this.state.showFilters;
    // this.setState({ showFilters: show });
    // LIMPIAR EL FILTRO SI SE ESCONDE EL TAGFILTER Y SI EXISTEN FILTROS
    // if (!show && this.state.selectedFilters.length > 0) {
    //   this.setState({ selectedFilters: [] });
    //   this.doFilter();
    // }
  };

  handleTextChange = (e) => {
    this.setState({ textSearch: e.value });
    if (!e.value) {
      this.doFilter();
    }
  };

  handleEnter = (e) => {
    this.doFilter();
  };

  doFilter = (selectMainFilter) => {
    this.props.onChange(
      this.state.textSearch,
      this.state.selectedFilters,
      selectMainFilter
    );
  };

  handleFiltersChange = (filter) => {
    let newFilter = [...this.state.selectedFilters];
    newFilter = newFilter.filter((f) => f.column !== filter[0].column);
    filter.forEach((f) => {
      if (f.value) {
        newFilter.push(f);
      }
    });

    this.setState({ selectedFilters: newFilter });
    this.doFilter();
  };

  handleMainFilter = (selected) => {
    if (selected.value.value !== "TODAS") {
      let newFilter = [...this.state.selectedFilters];
      let firstFilter = { column: selected.column, value: selected.value };
      newFilter.forEach((e, i) => {
        if (e.column === firstFilter.column) {
          newFilter.splice(i, 1);
        }
      });
      newFilter = [...newFilter, firstFilter];
      this.setState({ selectedFilters: newFilter });
    } else {
      this.setState({ selectedFilters: [] });
      this.props.optionMainFilterSelected(selected.value.value);
    }
    this.doFilter(selected);
  };

  handleTagChange = (e) => {
    this.setState({ selectedFilters: e.value });
    this.doFilter();
  };

  render() {
    const {
      show,
      placeholder,
      buttons,
      selectedMainFilter,
      mainFilter,
      format,
    } = this.props;
    const { showFilters, focus } = this.state;

    let anyButton = false;
    if (buttons)
      anyButton =
        (buttons.document && buttons.document.visible) ||
        (buttons.download && buttons.download.visible) ||
        (buttons.filter && buttons.filter.visible) ||
        (buttons.newItem && buttons.newItem.visible);

    if (!show) return null;
    return (
      <div>
        {mainFilter && mainFilter.length > 0 && (
          <SelectTipo
            selected={selectedMainFilter}
            onClick={this.handleMainFilter}
            items={mainFilter}
          />
        )}

        <div
          className={`headaer-filter-wrapper ${showFilters ? "show" : "hide"}`}
        >
          <div
            className="header-filter-text-wrapper"
            style={{
              paddingRightButton: 5
            }}
          >
            <TextBox
              height={35}
              className={`header-filter-textbox ${showFilters ? "show" : "_"} ${
                focus ? "dx-state-focused" : "-"
              }`}
              mode="search"
              onFocusIn={() => {
                this.setState({ focus: true });
              }}
              onFocusOut={() => {
                this.setState({ focus: false });
              }}
              placeholder={placeholder}
              onValueChanged={this.handleTextChange}
              onEnterKey={this.handleEnter}
              valueChangeEvent="input"
            />

            <TagBox
              className={`header-filter-tagbox ${
                focus ? "dx-state-focused" : "-"
              }`}
              onInitialized={(e) => {
                e && e.component && e.component.option("openOnFieldClick", false);
              }}
              searchEnabled={false}
              multiline
              showClearButton
              displayExpr="value.text"
              items={this.state.selectedFilters}
              onValueChanged={this.handleTagChange}
              value={this.state.selectedFilters}
              onFocusIn={() => {
                this.setState({ focus: true });
              }}
              onFocusOut={() => {
                this.setState({ focus: false });
              }}
              placeholder="Filtros"
            />

            <div className="filters-wrapper">
              {this.props.filters &&
                this.props.filters.map((filtro) => {
                  if (filtro.type === filterType.date) {
                    return (
                      <RangeFilter
                        key={filtro.column}
                        filterText={filtro.name}
                        column={filtro.column}
                        max={filtro.max}
                        oneYearInterval={filtro.oneYearInterval}
                        onFilter={this.handleFiltersChange}
                        selectedValues={this.state.selectedFilters.filter(
                          (f) => f.column === filtro.column
                        )}
                      />
                    );
                  }
                  if (filtro.type === filterType.number) {
                    return (
                      <NumberRangeFilter
                        key={filtro.column}
                        filterText={filtro.name}
                        format={format}
                        column={filtro.column}
                        onFilter={this.handleFiltersChange}
                        selectedValues={this.state.selectedFilters.filter(
                          (f) => f.column === filtro.column
                        )}
                      />
                    );
                  }

                  return (
                    <TableFilterSelect
                      key={filtro.column}
                      filterText={filtro.name}
                      column={filtro.column}
                      values={filtro.values}
                      filterValue={
                        filtro.type !== undefined ? filtro.filterValue : null
                      }
                      showName={
                        filtro.showName !== undefined ? filtro.showName : false
                      }
                      datatype={filtro.type !== undefined ? filtro.type : null}
                      selectedValues={this.state.selectedFilters.filter(
                        (f) => f.column === filtro.column
                      )}
                      onFilter={this.handleFiltersChange}
                    />
                  );
                })}
            </div>
          </div>

          {buttons !== undefined && buttons.document
           ? buttons.document.visible && (
               <div>
                 <Button
                   id={"btnVerDoc"}
                   height={35}
                   className="header-filter-button"
                   visible={
                     buttons !== undefined && buttons.document
                       ? buttons.document.visible
                       : false
                   }
                 >
                   <i
                     onMouseOver={this.handleShowFilterPrev}
                     onMouseLeave={this.handleShowFilterPrevOut}
                     className="achs-icon search-bar-icon"
                   >
                     l
                   </i>
                 </Button>
                 {this.state.showBtnFilterPrev && (
                   <Tooltip
                     visible={this.state.showBtnFilterPrev}
                     contentRender={() => (
                       <div>Previsualiza un documento con el listado</div>
                     )}
                     position="top"
                     className="header-filter-button"
                     closeOnOutsideClick
                     target="#btnVerDoc"
                   />
                 )}
               </div>
             )
           : null}

          {buttons !== undefined && buttons.download
           ? buttons.download.visible && (
               <div>
                 <Button
                   id={"btnDescargarDoc"}
                   height={35}
                   className="header-filter-button"
                   visible={
                     buttons !== undefined && buttons.download
                       ? buttons.download.visible
                       : false
                   }
                   onClick={buttons.download.buttonAction}
                   disabled={buttons.download.active}
                 >
                   <i
                     onMouseOver={this.handleShowFilterDown}
                     onMouseLeave={this.handleShowFilterDownOut}
                     className="achs-icon search-bar-icon"
                   >
                     z
                   </i>
                 </Button>
                 {this.state.showBtnFilterDown && (
                   <Tooltip
                     visible={this.state.showBtnFilterDown}
                     closeOnOutsideClick
                     contentRender={() => <div>Descargar listado a Excel</div>}
                     position="top"
                     className="header-filter-button"
                     target="#btnDescargarDoc"
                   />
                 )}
               </div>
             )
           : null}

          {buttons !== undefined &&
          buttons.newItem &&
          buttons.newItem.visible === true ? (
           <Button
             height={35}
             className="header-filter-button"
             text={buttons.newItem.buttonText}
             onClick={buttons.newItem.buttonAction}
             type="success"
           />
          ) : null}
        </div>
      </div>
    );
  }
}

export default TableFilter;
